import {DataARTransactionItemModel} from './data-ar-transaction-item.model';

export class PostTransactionItemModel {
  LOCID: number;
  PatientId: string;
  transactionItems: DataARTransactionItemModel[];
  ProviderDoctorId: string;
}
